/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Genre_FictionInputs */

const en_onboarding_genre_fiction = /** @type {(inputs: Onboarding_Genre_FictionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiction`)
};

const es_onboarding_genre_fiction = /** @type {(inputs: Onboarding_Genre_FictionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ficción`)
};

/**
* | output |
* | --- |
* | "Fiction" |
*
* @param {Onboarding_Genre_FictionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_genre_fiction = /** @type {((inputs?: Onboarding_Genre_FictionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Genre_FictionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_genre_fiction(inputs)
	return en_onboarding_genre_fiction(inputs)
});